"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["HOVERED"] = "hovered";
    ActionType["UNHOVERED"] = "unhovered";
    ActionType["SELECTED"] = "selected";
    ActionType["ZOOM_IN"] = "zoomIn";
    ActionType["ZOOM_OUT"] = "zoomOut";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
